export default __webpack_public_path__ + "static/media/logo_sindilegis.414fe32e.svg";